import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ViewController, LoadingController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the RoomdetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-roomdetail',
  templateUrl: 'roomdetail.html',
})
export class RoomdetailPage {
    loginId: string;
	email: string;
    api_key: string;
    version: string;

    title: string;
    balance: string;
    from: string;
    name: string;
    date: string;

	coin_unit: string;
	unit: string;
	cash_room_unit: string;
	bonus_room_unit: string;

    list: any = [];

	texts: any = [];
    language : string;

    constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
        public viewCtrl: ViewController,
		public loadingCtrl: LoadingController,
		public app: App
    ) {
        this.from = this.navParams.get('from');
        this.name = this.navParams.get('name');
        this.date = this.navParams.get('date');
	}

    ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "bonusdetail");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.cash_room_unit = localStorage.getItem("cash_room_unit");
		this.bonus_room_unit = localStorage.getItem("bonus_room_unit");

        this._get_texts();

        if (this.from == 'cash') {
            this.unit = this.cash_room_unit;
        } else {
            this.unit = this.bonus_room_unit;
        }

        this._init();
	}

    _get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).bonusdetail;
	}

	_init() {
        let loader = this.loadingCtrl.create({
            content: "loading..."
        });
        loader.present();

        let url;
        if (this.from == 'cash') {
            url = "room/cash/index/detail";
        } 
        if (this.from == 'bonus') {
            url = "room/bonus/index/detail";
        }

		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version,
            name: this.name,
            date: this.date
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.title = res.title
                this.balance = res.balance
                if (res.list != undefined) {
                    this.list = res.list;
                }
				
                loader.dismiss();
				// if(res.list != undefined) {
				// 	this.list = res.list;
				// 	this.max_length = res.list.length;
				// 	this.params = [];
				// 	this.count = 0;
				// 	for (var i = 0; i < 9; i++) {
				// 		if(this.max_length <= this.count) break;
				// 		this.params.push(this.items[this.count]);
				// 		this.count++;
				// 	}
				// }
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();
                loader.dismiss();
                this._close();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                loader.dismiss();
                this._close();

				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                loader.dismiss();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
            loader.dismiss();
            this._close();
		});
	}

    _close() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/roomdetail/roomdetail.ts